import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../../Constant/Static/config";
import { AuthContext } from "../../../Auth/AuthContext";
import axios from "axios";
import PopModal from "../../../Constant/Custom/Models/PopModal";

function AdminCertUpload({userInfo}) {
  const { auth } = useContext(AuthContext);
  const storedUser = auth.user;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: "", text: "", icon: "" });
  const [onConfirm, setOnConfirm] = useState(() => () => { });
  const [onCancel, setOnCancel] = useState(() => () => { });
  const [showCancelButton, setShowCancelButton] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [files, setFiles] = useState({
    communityCertificate: null,
    nativityCertificate: null,
    tenthMarksheet: null,
    twelfthMarksheet: null,
    provisionalCertificate: null,
    consolidatedMarksheet: null,
    semesterOne: null,
    semesterTwo: null,
    semesterThree: null,
    semesterFour: null,
    semesterFive: null,
    semesterSix: null,
    semesterSeven: null,
    semesterEight: null,
    transferCertificate: null,
    aadhar: null,
    firstGraduate: null,
    sportsCertificate6: null,
    sportsCertificate6: null,
    sportsCertificate5: null,
    sportsCertificate4: null,
    sportsCertificate3: null,
    sportsCertificate2: null,
    sportsCertificate1: null,
    disabilityCertificate1: null,
    disabilityCertificate2: null,
    disabilityCertificate3: null,
    isabilityCertificate: null,
    transferCertificate: null,
    exServicemanCertificate1: null,
    exServicemanCertificate2: null,
    exServicemanCertificate3: null,
  });
  const [previewCert, setPreviewCert] = useState({
    communityCertificate: "",
    nativityCertificate: "",
    tenthMarksheet: "",
    twelfthMarksheet: "",
    provisionalCertificate: "",
    consolidatedMarksheet: "",
    semesterOne: null,
    semesterTwo: null,
    semesterThree: null,
    semesterFour: null,
    semesterFive: null,
    semesterSix: null,
    semesterSeven: null,
    semesterEight: null,
    transferCertificate: "",
    aadhar: "",
    firstGraduate: "",
    sportsCertificate6: "",
    sportsCertificate6: "",
    sportsCertificate5: "",
    sportsCertificate5: "",
    sportsCertificate4: "",
    sportsCertificate3: "",
    sportsCertificate2: "",
    sportsCertificate1: "",
    isabilityCertificate: "",
    transferCertificate: "",
    disabilityCertificate1: "",
    disabilityCertificate2: "",
    disabilityCertificate3: "",
    exServicemanCertificate1: "",
    exServicemanCertificate2: "",
    exServicemanCertificate3: "",
  });
  const [uploadProgress, setUploadProgress] = useState({
    communityCertificate: 0,
    nativityCertificate: 0,
    tenthMarksheet: 0,
    twelfthMarksheet: 0,
    provisionalCertificate: 0,
    consolidatedMarksheet: 0,
    transferCertificate: 0,
    aadhar: 0,
    firstGraduate: 0,
    sportsCertificate6: 0,
    sportsCertificate5: 0,
    sportsCertificate4: 0,
    sportsCertificate3: 0,
    sportsCertificate2: 0,
    sportsCertificate1: 0,
    isabilityCertificate: 0,
    disabilityCertificate1: 0,
    disabilityCertificate2: 0,
    disabilityCertificate3: 0,
    exServicemanCertificate1: 0,
    exServicemanCertificate2: 0,
    exServicemanCertificate3: 0,
    semesterOne: 0,
    semesterTwo: 0,
    semesterThree: 0,
    semesterFour: 0,
    semesterFive: 0,
    semesterSix: 0,
    semesterSeven: 0,
    semesterEight: 0,
  });
  const [haveConsolidate, setHaveConsolidate] = useState(0);
  const [csrfToken, setCsrfToken] = useState("");
  const [spldata, setspldata] = useState({});
  const [showReservation, setShowReservation] = useState(false);
  const navigate = useNavigate();
  const [downloading, setDownloading] = useState(false);

  const defaultForm = () => {
    setFiles({
      communityCertificate: null,
      nativityCertificate: null,
      tenthMarksheet: null,
      twelfthMarksheet: null,
      provisionalCertificate: null,
      consolidatedMarksheet: null,
      transferCertificate: null,
      aadhar: null,
      firstGraduate: null,
    });
  };
  const [message, setMessage] = useState("");



  const handleDownload = async () => {
    try {
      const userDataFromLocalStorage = auth.user;
      // console.log("User from localstorage", userDataFromLocalStorage);

      setDownloading(true);
      if (userDataFromLocalStorage) {
        const response = await axios.post(`${serverUrl}/api/user/doc/certificate-list`, {
          appNo: userInfo.APPLN_NO,
          userName: userInfo.APPLICANT_NAME
        },
          {
            headers: {
              'CSRF-Token': csrfToken
            },
            withCredentials: true,
            responseType: 'blob'
          }
        );

        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute("download", `Certificate-List-${userInfo.APPLN_NO}.pdf`);
          document.body.appendChild(link);
          link.click();
        } else {
          console.log("Error")
        }

      }
    } catch (error) {
      console.error(error)
    } finally {
      setDownloading(false)
    }
  }

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    const file = selectedFiles[0];
    // console.log(file);

    // Validate file type and size
    const validTypes = ["image/jpeg", "image/jpg", "image/png","image/JPEG", "image/JPG", "image/PNG", "application/pdf"];
    const maxFileSizes = {
      communityCertificate: 301 * 1024,
      nativityCertificate: 301 * 1024, // 500 KB
      tenthMarksheet: 301 * 1024,
      twelfthMarksheet: 301 * 1024,
      provisionalCertificate: 301 * 1024,
      consolidatedMarksheet: 301 * 1024,
      transferCertificate: 301 * 1024,
      aadhar: 301 * 1024,
      firstGraduate: 301 * 1024,
      sportsCertificate6: 301 * 1024,
      sportsCertificate5: 301 * 1024,
      sportsCertificate4: 301 * 1024,
      sportsCertificate3: 301 * 1024,
      sportsCertificate2: 301 * 1024,
      sportsCertificate1: 301 * 1024,
      isabilityCertificate: 301 * 1024,
      disabilityCertificate1: 301 * 1024,
      disabilityCertificate2: 301 * 1024,
      disabilityCertificate3: 301 * 1024,
      exServicemanCertificate1: 301 * 1024,
      exServicemanCertificate2: 301 * 1024,
      exServicemanCertificate3: 301 * 1024,
      semesterOne: 301 * 1024,
      semesterTwo: 301 * 1024,
      semesterThree: 301 * 1024,
      semesterFour: 301 * 1024,
      semesterFive: 301 * 1024,
      semesterSix: 301 * 1024,
      semesterSeven: 301 * 1024,
      semesterEight: 301 * 1024,
    };

    if (file) {
      if (!validTypes.includes(file.type) || file.size > maxFileSizes[name]) {
        setModalType({
          icon: "info",
          title: "Invalid file",
          text: `Please upload a valid ${name.replace(
            /Certificate/g,
            " Certificate"
          )} (JPG/JPEG/PNG/PDF) under ${(maxFileSizes[name] / 1024) - 1}KB.`,
        });

        setShowCancelButton(false);
        openModal();

        // setOnCancel(() => closeModal);
        // setOnCancel(() => closeModal);
        setOnConfirm(() => () => {
          closeModal();
        });

        return;
      }

      setFiles((prevState) => ({
        ...prevState,
        [name]: file,
      }));

      handleFileUpload(name, file);
    }
  };
  const handleFileUpload = async (name, file) => {
    // console.log(name, ":", file);
    const formData = new FormData();
    formData.append("appno",userInfo.APPLN_NO);
    formData.append("mobile",userInfo.MOBILE);
    formData.append(name, file);
    // console.log("Send Data: ", formData);

    try {
      await axios.post(`${serverUrl}/api/certificate-upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress((prev) => ({ ...prev, [name]: progress }));
        },
      });

      setModalType({
        icon: "success",
        title: "File Upload",
        text: "File Uploaded successfully",
      });

      setShowCancelButton(false);
      openModal();

      // setOnCancel(() => closeModal);
      setOnConfirm(() => () => {
        fetchUploadedImages();
        closeModal();
      });
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("Error uploading file.");
    }
  };

  const handleFileDelete = async (fileUrl) => {
    try {
      // console.log("Deleting file:", fileUrl);

      const deletedField = Object.keys(previewCert).find(
        (key) => previewCert[key] === fileUrl
      );

      if (!deletedField) {
        console.warn("No matching field found for fileUrl.");
        return;
      }

      // Define the delete handler WITH the needed context
      const deleteFile = async () => {
        try {
          setPreviewCert((prev) => ({
            ...prev,
            [deletedField]: null,
          }));

          const response = await axios.post(`${serverUrl}/api/delete-file`, {
            fileUrl,
            filename: deletedField,
            appno: userInfo.APPLN_NO,
            mobile: userInfo.MOBILE,
          });

          // console.log(
          //   "File deleted successfully:",
          //   response.data?.message || response.statusText
          // );


          if (response.status === 200) {

            setModalType({
              icon: "success",
              title: "File Deletion",
              text: "File Deleted Successfully",
            });

            setShowCancelButton(false);
            openModal();

            // setOnCancel(() => closeModal);
            setOnConfirm(() => () => {
              fetchUploadedImages();
              closeModal();
            });
          }
        } catch (error) {
          if (error.response.status === 404) {
            setModalType({
              icon: "error",
              title: "File Deletion",
              text: "File Not Found",
            });

            setShowCancelButton(false);
            openModal();

            // setOnCancel(() => closeModal);
            setOnConfirm(() => () => {
              closeModal();
            });
          } else if (error.response.status === 500) {
            setModalType({
              icon: "error",
              title: "File Deletion",
              text: "Error in deleting file. Please try again later..",
            });

            setShowCancelButton(false);
            openModal();

            // setOnCancel(() => closeModal);
            setOnConfirm(() => () => {
              closeModal();
            });
          }

          console.error("Error deleting file on server:", error);
        }
      };

      // Show modal
      setModalType({
        icon: "warning",
        title: "File Deletion",
        text: "You want to delete this file ?",
      });

      setShowCancelButton(true);
      openModal();
      setOnCancel(() => closeModal);
      setOnConfirm(() => () => deleteFile());
    } catch (error) {
      console.error("Error preparing file deletion:", error);
    }
  };

  useEffect(() => {
    // console.log(userInfo);
    
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/csrf-token`, {
          withCredentials: true,
        });
        setCsrfToken(response.data.csrfToken);
      } catch (error) {
        console.error("Error fetching CSRF token:", error);
      }
    };

    fetchCsrfToken();
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      if (csrfToken) {
        try {
          const userDataFromLocalStorage = auth.user;
          if (userDataFromLocalStorage) {
            const response = await axios.post(
              `${serverUrl}/api/user/loadcertInfo`,
              {
                appno: userInfo.APPLN_NO,
                userName: userInfo.APPLICANT_NAME,
                email: userInfo.EMAIL,
                mobile: userInfo.MOBILE,
              },
              {
                headers: {
                  "CSRF-Token": csrfToken, // Use CSRF token
                },
                withCredentials: true,
              }
            );
            setspldata(response.data);

            setShowReservation(() => {
              for (let key in response.data) {
                if (response.data[key] == "Y" && !key.startsWith('freedom') && !key.startsWith('srilankan')) return true
              }
              return false
            })
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        } finally {
          // setLoading(false);
        }
      }
    };

    fetchUserData();
  }, [csrfToken]);

  const fetchUploadedImages = async () => {
    const storedUser = auth.user;
    try {
      const response = await axios.post(`${serverUrl}/api/fetchCertificates`, {
        appno: userInfo.APPLN_NO,
        mobile: userInfo.MOBILE,
      });
      // console.log(response.data.uploadedPath);
      if (response.data) {
        setPreviewCert((prevState) => ({
          ...prevState,
          tenthMarksheet: response.data.uploadedPath.TENTH_MARKSHEET
            ? response.data.uploadedPath.TENTH_MARKSHEET
            : null,
          communityCertificate: response.data.uploadedPath.COMMUNITY_CERT
            ? response.data.uploadedPath.COMMUNITY_CERT
            : null,
          consolidatedMarksheet: response.data.uploadedPath
            .CONSOLIDATE_MARKSHEET
            ? response.data.uploadedPath.CONSOLIDATE_MARKSHEET
            : null,
          // pro: response.data.uploadedPath.PROVISIONAL_DEGREE_CERT ? response.data.uploadedPath.PROVISIONAL_DEGREE_CERT : null,
          transferCertificate: response.data.uploadedPath.TRANSFER_CERT
            ? response.data.uploadedPath.TRANSFER_CERT
            : null,
          nativityCertificate: response.data.uploadedPath.NATIVE_CERT
            ? response.data.uploadedPath.NATIVE_CERT
            : null,
          aadhar: response.data.uploadedPath.AADHAR
            ? response.data.uploadedPath.AADHAR
            : null,
          firstGraduate: response.data.uploadedPath.FG_CERT
            ? response.data.uploadedPath.FG_CERT
            : null,
          twelfthMarksheet: response.data.uploadedPath.TWELFTH_MARKSHEET
            ? response.data.uploadedPath.TWELFTH_MARKSHEET
            : null,
          sportsCertificate1: response.data.uploadedPath.SPORT_CERT_1
            ? response.data.uploadedPath.SPORT_CERT_1
            : null,
          sportsCertificate2: response.data.uploadedPath.SPORT_CERT_2
            ? response.data.uploadedPath.SPORT_CERT_2
            : null,
          sportsCertificate3: response.data.uploadedPath.SPORT_CERT_3
            ? response.data.uploadedPath.SPORT_CERT_3
            : null,
          sportsCertificate4: response.data.uploadedPath.SPORT_CERT_4
            ? response.data.uploadedPath.SPORT_CERT_4
            : null,
          sportsCertificate5: response.data.uploadedPath.SPORT_CERT_5
            ? response.data.uploadedPath.SPORT_CERT_5
            : null,
          sportsCertificate6: response.data.uploadedPath.SPORT_CERT_6
            ? response.data.uploadedPath.SPORT_CERT_6
            : null,
          disabilityCertificate1: response.data.uploadedPath.DA_CERT_1
            ? response.data.uploadedPath.DA_CERT_1
            : null,
          disabilityCertificate2: response.data.uploadedPath.DA_CERT_2
            ? response.data.uploadedPath.DA_CERT_2
            : null,
          disabilityCertificate3: response.data.uploadedPath.DA_CERT_3
            ? response.data.uploadedPath.DA_CERT_3
            : null,
          exServicemanCertificate1: response.data.uploadedPath.EX_SERVICE_CERT_1
            ? response.data.uploadedPath.EX_SERVICE_CERT_1
            : null,
          exServicemanCertificate2: response.data.uploadedPath.EX_SERVICE_CERT_2
            ? response.data.uploadedPath.EX_SERVICE_CERT_2
            : null,
          exServicemanCertificate3: response.data.uploadedPath.EX_SERVICE_CERT_3
            ? response.data.uploadedPath.EX_SERVICE_CERT_3
            : null,
          semesterOne: response.data.uploadedPath.SEM1
            ? response.data.uploadedPath.SEM1
            : null,
          semesterTwo: response.data.uploadedPath.SEM2
            ? response.data.uploadedPath.SEM2
            : null,
          semesterThree: response.data.uploadedPath.SEM3
            ? response.data.uploadedPath.SEM3
            : null,
          semesterFour: response.data.uploadedPath.SEM4
            ? response.data.uploadedPath.SEM4
            : null,
          semesterFive: response.data.uploadedPath.SEM5
            ? response.data.uploadedPath.SEM5
            : null,
          semesterSix: response.data.uploadedPath.SEM6
            ? response.data.uploadedPath.SEM6
            : null,
          semesterSeven: response.data.uploadedPath.SEM7
            ? response.data.uploadedPath.SEM7
            : null,
          semesterEight: response.data.uploadedPath.SEM8
            ? response.data.uploadedPath.SEM8
            : null,
          provisionalCertificate: response.data.uploadedPath
            .PROVISIONAL_DEGREE_CERT
            ? response.data.uploadedPath.PROVISIONAL_DEGREE_CERT
            : null,
        }));
        setUploadProgress((prevState) => ({
          ...prevState,
          tenthMarksheet: response.data.uploadedPath.TENTH_MARKSHEET
            ? prevState['tenthMarksheet']
            : 0,
          communityCertificate: response.data.uploadedPath.COMMUNITY_CERT
            ? prevState['communityCertificate']
            : 0,
          consolidatedMarksheet: response.data.uploadedPath
            .CONSOLIDATE_MARKSHEET
            ? prevState['consolidatedMarksheet']
            : 0,
          // pro: response.data.uploadedPath.PROVISIONAL_DEGREE_CERT ? response.data.uploadedPath.PROVISIONAL_DEGREE_CERT : null,
          transferCertificate: response.data.uploadedPath.TRANSFER_CERT
            ? prevState['transferCertificate']
            : 0,
          nativityCertificate: response.data.uploadedPath.NATIVE_CERT
            ? prevState['nativityCertificate']
            : 0,
          aadhar: response.data.uploadedPath.AADHAR
            ? prevState['aadhar']
            : 0,
          firstGraduate: response.data.uploadedPath.FG_CERT
            ? prevState['firstGraduate']
            : 0,
          twelfthMarksheet: response.data.uploadedPath.TWELFTH_MARKSHEET
            ? prevState['twelfthMarksheet']
            : 0,
          sportsCertificate1: response.data.uploadedPath.SPORT_CERT_1
            ? prevState['sportsCertificate1']
            : 0,
          sportsCertificate2: response.data.uploadedPath.SPORT_CERT_2
            ? prevState['sportsCertificate2']
            : 0,
          sportsCertificate3: response.data.uploadedPath.SPORT_CERT_3
            ? prevState['sportsCertificate3']
            : 0,
          sportsCertificate4: response.data.uploadedPath.SPORT_CERT_4
            ? prevState['sportsCertificate4']
            : 0,
          sportsCertificate5: response.data.uploadedPath.SPORT_CERT_5
            ? prevState['sportsCertificate5']
            : 0,
          sportsCertificate6: response.data.uploadedPath.SPORT_CERT_6
            ? prevState['sportsCertificate6']
            : 0,
          disabilityCertificate1: response.data.uploadedPath.DA_CERT_1
            ? prevState['disabilityCertificate1']
            : 0,
          disabilityCertificate2: response.data.uploadedPath.DA_CERT_1
            ? prevState['disabilityCertificate2']
            : 0,
          disabilityCertificate3: response.data.uploadedPath.DA_CERT_1
            ? prevState['disabilityCertificate3']
            : 0,
          exServicemanCertificate1: response.data.uploadedPath.EX_SERVICE_CERT_1
            ? prevState['exServicemanCertificate1']
            : 0,
          exServicemanCertificate2: response.data.uploadedPath.EX_SERVICE_CERT_2
            ? prevState['exServicemanCertificate2']
            : 0,
          exServicemanCertificate3: response.data.uploadedPath.EX_SERVICE_CERT_3
            ? prevState['exServicemanCertificate3']
            : 0,
          semesterOne: response.data.uploadedPath.SEM1
            ? prevState['semesterOne']
            : 0,
          semesterTwo: response.data.uploadedPath.SEM2
            ? prevState['semesterTwo']
            : 0,
          semesterThree: response.data.uploadedPath.SEM3
            ? prevState['semesterThree']
            : 0,
          semesterFour: response.data.uploadedPath.SEM4
            ? prevState['semesterFour']
            : 0,
          semesterFive: response.data.uploadedPath.SEM5
            ? prevState['semesterFive']
            : 0,
          semesterSix: response.data.uploadedPath.SEM6
            ? prevState['semesterSix']
            : 0,
          semesterSeven: response.data.uploadedPath.SEM7
            ? prevState['semesterSeven']
            : 0,
          semesterEight: response.data.uploadedPath.SEM8
            ? prevState['semesterEight']
            : 0,
          provisionalCertificate: response.data.uploadedPath
            .PROVISIONAL_DEGREE_CERT
            ? prevState['provisionalCertificate']
            : 0,
        }));
      }
      // if (response.data.signatureUrl) {
      //     setPreviewCert(response.data.signatureUrl);
      // }
      if (response.data.uploadedPath.CONSOLIDATE_MARKSHEET) {

        setHaveConsolidate(1);
      } else {
        setHaveConsolidate(0);
      }
    } catch (err) {
      console.error("Error fetching uploaded images", err);
    }
  };

  // useEffect(() => {
  //   let timer;
  //   if (uploadProgress > 0 && uploadProgress < 100) {
  //     timer = setInterval(() => {
  //       setUploadProgress((prev) => Math.min(prev + 5, 99));
  //     }, 100);
  //   }
  //   return () => clearInterval(timer);
  // }, [uploadProgress]);

  useEffect(() => {
    fetchUploadedImages();
  }, [files]);
  // useEffect(()=>{

  // },[haveConsolidate])

  // const handleSubmit = async (e) => {
  //     e.preventDefault();
  //     setMessage('');

  //     const formData = new FormData();
  //     for (const key in files) {
  //         formData.append(key, files[key]);
  //     }

  //     try {
  //         // Replace with your API endpoint
  //         const response = await fetch(`${serverUrl}/api/user/upload`, {
  //             method: 'POST',
  //             body: formData,
  //         });

  //         if (!response.ok) {
  //             throw new Error('File upload failed');
  //         }

  //         setMessage('Files uploaded successfully!');
  //         setFiles({});
  //     } catch (error) {
  //         setMessage(`Error: ${error.message}`);
  //     }
  // };

  return (
    <div className="upload-container">
      <h2>Upload Certificates</h2>
      {/* <h3 style={{color:"#dc2626",textAlign:'center',marginLeft:'8%',width:"80%"}}> Only files in JPEG, JPG, PNG, or PDF format are allowed. Please ensure your file meets this requirement before uploading. The file size should be below 300 KB.</h3>
      <h3 style={{color:"#dc2626",textAlign:'center',marginLeft:'8%',width:"80%"}}> All fields marked with an asterisk (*) are mandatory.</h3> */}
      <h3 style={{color:"#1890FF",textAlign:'center',marginLeft:'8%',width:"80%"}}> Only files in JPEG, JPG, PNG, or PDF format are allowed. Please ensure your file meets this requirement before uploading. The file size should be below 300 KB.</h3>
      <h3 style={{color:"#1890FF",textAlign:'center',marginLeft:'8%',width:"80%"}}> All fields marked with an asterisk (*) are mandatory.</h3>
      <div>
        <div>
          <section>
            <h3>Mandatory Certificates</h3>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h4>Do you have Consolidate MarkSheet?&ensp;</h4>
              <div>
                <label style={{ padding: "0rem 1rem" }}>
                  <input
                    type="radio"
                    name="haveConsolidate"
                    aria-label="Yes"
                    value={1}
                    checked={haveConsolidate === 1}
                    style={{ transform: "scale(1.25)", marginRight: "10px" }}
                    onChange={() => setHaveConsolidate(1)}
                  />
                  Yes
                </label>
                <label style={{ padding: "0rem 1rem" }}>
                  <input
                    type="radio"
                    name="haveConsolidate"
                    aria-label="No"
                    value={0}
                    checked={haveConsolidate === 0}
                    style={{ transform: "scale(1.25)", marginRight: "10px" }}
                    onChange={() => setHaveConsolidate(0)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="communityCertificate">
                Community Certificate (If Applicable):
              </label>
              {uploadProgress.communityCertificate > 0 && (
                <div>
                  <progress value={uploadProgress.communityCertificate} max="100" />
                  <span>{uploadProgress.communityCertificate}%</span>
                </div>
              )}
              {!previewCert.communityCertificate ? (
                <>
                  <input
                    type="file"
                    name="communityCertificate"
                    onChange={handleFileChange}
                    // required
                    disabled={previewCert.communityCertificate}
                  />
                </>
              ) : (
                <>

                  <div>
                  </div>

                  <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      alignItems: "center",
                      width: "100%",
                      margin: "10px 0px",
                    }}
                  >
                    <a
                      className="viewButton"
                      href={`${previewCert.communityCertificate}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </a>
                    <button
                      className="deleteButton"
                      onClick={() =>
                        handleFileDelete(previewCert.communityCertificate)
                      }
                    >
                      Delete
                    </button>
                  </div>
                </>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="nativityCertificate">
                Nativity Certificate (If Applicable):
              </label>
              {uploadProgress.nativityCertificate > 0 && (
                <div>
                  <progress value={uploadProgress.nativityCertificate} max="100" />
                  <span>{uploadProgress.nativityCertificate}%</span>
                </div>
              )}
              {!previewCert.nativityCertificate ? (
                <input
                  type="file"
                  name="nativityCertificate"
                  onChange={handleFileChange}
                  // required
                  disabled={previewCert.nativityCertificate}
                />
              ) : (
                <>
                  <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      alignItems: "center",
                      width: "100%",
                      margin: "10px 0px",
                    }}
                  >
                    <a
                      className="viewButton"
                      href={`${previewCert.nativityCertificate}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </a>
                    <button
                      className="deleteButton"
                      onClick={() =>
                        handleFileDelete(previewCert.nativityCertificate)
                      }
                    >
                      Delete
                    </button>
                  </div>
                </>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="tenthMarksheet">
                <span className="mandatory">*</span>10<sup>th</sup> Marksheet :
              </label>
              {uploadProgress.tenthMarksheet > 0 && (
                <div>
                  <progress value={uploadProgress.tenthMarksheet} max="100" />
                  <span>{uploadProgress.tenthMarksheet}%</span>
                </div>
              )}
              {!previewCert.tenthMarksheet ? (
                <input
                  type="file"
                  name="tenthMarksheet"
                  onChange={handleFileChange}
                  required
                  disabled={previewCert.tenthMarksheet}
                />
              ) : (
                <>
                  <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      alignItems: "center",
                      width: "100%",
                      margin: "10px 0px",
                    }}
                  >
                    <a
                      className="viewButton"
                      href={`${previewCert.tenthMarksheet}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </a>
                    <button
                      className="deleteButton"
                      onClick={() => handleFileDelete(previewCert.tenthMarksheet)}
                    >
                      Delete
                    </button>
                  </div>
                </>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="twelfthMarksheet">12th Marksheet :</label>
              {uploadProgress.twelfthMarksheet > 0 && (
                <div>
                  <progress value={uploadProgress.twelfthMarksheet} max="100" />
                  <span>{uploadProgress.twelfthMarksheet}%</span>
                </div>
              )}
              {!previewCert.twelfthMarksheet ? (
                <input
                  type="file"
                  name="twelfthMarksheet"
                  onChange={handleFileChange}
                  // required
                  disabled={previewCert.twelfthMarksheet}
                />
              ) : (
                <>
                  <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      alignItems: "center",
                      width: "100%",
                      margin: "10px 0px",
                    }}
                  >
                    <a
                      className="viewButton"
                      href={`${previewCert.twelfthMarksheet}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </a>
                    <button
                      className="deleteButton"
                      onClick={() =>
                        handleFileDelete(previewCert.twelfthMarksheet)
                      }
                    >
                      Delete
                    </button>
                  </div>
                </>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="provisionalCertificate">
                Provisional (or) Degree Completion Certificate :
              </label>
              {uploadProgress.provisionalCertificate > 0 && (
                <div>
                  <progress value={uploadProgress.provisionalCertificate} max="100" />
                  <span>{uploadProgress.provisionalCertificate}%</span>
                </div>
              )}
              {!previewCert.provisionalCertificate ? (
                <input
                  type="file"
                  name="provisionalCertificate"
                  onChange={handleFileChange}
                  // required
                  disabled={previewCert.provisionalCertificate}
                />
              ) : (
                <>
                  <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      alignItems: "center",
                      width: "100%",
                      margin: "10px 0px",
                    }}
                  >
                    <a
                      className="viewButton"
                      href={`${previewCert.provisionalCertificate}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </a>
                    <button
                      className="deleteButton"
                      onClick={() =>
                        handleFileDelete(previewCert.provisionalCertificate)
                      }
                    >
                      Delete
                    </button>
                  </div>
                </>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="transferCertificate">
                Transfer Certificate :
              </label>
              {uploadProgress.transferCertificate > 0 && (
                <div>
                  <progress value={uploadProgress.transferCertificate} max="100" />
                  <span>{uploadProgress.transferCertificate}%</span>
                </div>
              )}
              {!previewCert.transferCertificate ? (
                <input
                  type="file"
                  name="transferCertificate"
                  onChange={handleFileChange}
                  // required
                  disabled={previewCert.transferCertificate}
                />
              ) : (
                <>
                  <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      alignItems: "center",
                      width: "100%",
                      margin: "10px 0px",
                    }}
                  >
                    <a
                      className="viewButton"
                      href={`${previewCert.transferCertificate}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </a>
                    <button
                      className="deleteButton"
                      onClick={() =>
                        handleFileDelete(previewCert.transferCertificate)
                      }
                    >
                      Delete
                    </button>
                  </div>
                </>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="aadhar">Aadhar :
              </label>
              {uploadProgress.aadhar > 0 && (
                <div>
                  <progress value={uploadProgress.aadhar} max="100" />
                  <span>{uploadProgress.aadhar}%</span>
                </div>
              )}
              {!previewCert.aadhar ? (
                <input
                  type="file"
                  name="aadhar"
                  onChange={handleFileChange}
                  disabled={previewCert.aadhar}
                />
              ) : (
                <>
                  <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      alignItems: "center",
                      width: "100%",
                      margin: "10px 0px",
                    }}
                  >
                    <a
                      className="viewButton"
                      href={`${previewCert.aadhar}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </a>
                    <button
                      className="deleteButton"
                      onClick={() => handleFileDelete(previewCert.aadhar)}
                    >
                      Delete
                    </button>
                  </div>
                </>
              )}
            </div>
            {haveConsolidate === 1 ? (
              <div className="form-group">
                <label htmlFor="consolidatedMarksheet">
                  Consolidated Marksheet :
                </label>
                {uploadProgress.consolidatedMarksheet > 0 && (
                  <div>
                    <progress value={uploadProgress.consolidatedMarksheet} max="100" />
                    <span>{uploadProgress.consolidatedMarksheet}%</span>
                  </div>
                )}
                {!previewCert.consolidatedMarksheet ? (
                  <input
                    type="file"
                    name="consolidatedMarksheet"
                    onChange={handleFileChange}
                    disabled={previewCert.consolidatedMarksheet}
                  />
                ) : (
                  <>
                    <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "right",
                        alignItems: "center",
                        width: "100%",
                        margin: "10px 0px",
                      }}
                    >
                      <a
                        className="viewButton"
                        href={`${previewCert.consolidatedMarksheet}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View
                      </a>
                      <button
                        className="deleteButton"
                        onClick={() =>
                          handleFileDelete(previewCert.consolidatedMarksheet)
                        }
                      >
                        Delete
                      </button>
                    </div>
                  </>
                )}
              </div>
            ) : (
              <>
                {(spldata.ctype === '6' ||
                  spldata.ctype === '7' ||
                  spldata.ctype === '71' ||
                  spldata.ctype === '8') && (
                    <div className="form-group">
                      <label htmlFor="semesterOne">Semester 1 Marksheet :</label>
                      {uploadProgress.semesterOne > 0 && (
                        <div>
                          <progress value={uploadProgress.semesterOne} max="100" />
                          <span>{uploadProgress.semesterOne}%</span>
                        </div>
                      )}
                      {!previewCert.semesterOne ? (
                        <input
                          type="file"
                          name="semesterOne"
                          onChange={handleFileChange}
                          disabled={previewCert.semesterOne}
                        />
                      ) : (
                        <>
                          <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "right",
                              alignItems: "center",
                              width: "100%",
                              margin: "10px 0px",
                            }}
                          >
                            <a
                              className="viewButton"
                              href={`${previewCert.semesterOne}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View
                            </a>
                            <button
                              className="deleteButton"
                              onClick={() =>
                                handleFileDelete(previewCert.semesterOne)
                              }
                            >
                              Delete
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                {(spldata.ctype === '6' ||
                  spldata.ctype === '7' ||
                  spldata.ctype === '71' ||
                  spldata.ctype === '8') && (
                    <div className="form-group">
                      <label htmlFor="semesterTwo">Semester 2 Marksheet :</label>
                      {uploadProgress.semesterTwo > 0 && (
                        <div>
                          <progress value={uploadProgress.semesterTwo} max="100" />
                          <span>{uploadProgress.semesterTwo}%</span>
                        </div>
                      )}
                      {!previewCert.semesterTwo ? (
                        <input
                          type="file"
                          name="semesterTwo"
                          onChange={handleFileChange}
                          disabled={previewCert.semesterTwo}
                        />
                      ) : (
                        <>
                          <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "right",
                              alignItems: "center",
                              width: "100%",
                              margin: "10px 0px",
                            }}
                          >
                            <a
                              className="viewButton"
                              href={`${previewCert.semesterTwo}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View
                            </a>
                            <button
                              className="deleteButton"
                              onClick={() =>
                                handleFileDelete(previewCert.semesterTwo)
                              }
                            >
                              Delete
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                <div className="form-group">
                  <label htmlFor="semesterThree">Semester 3 Marksheet :</label>
                  {uploadProgress.semesterThree > 0 && (
                    <div>
                      <progress value={uploadProgress.semesterThree} max="100" />
                      <span>{uploadProgress.semesterThree}%</span>
                    </div>
                  )}
                  {!previewCert.semesterThree ? (
                    <input
                      type="file"
                      name="semesterThree"
                      onChange={handleFileChange}
                      disabled={previewCert.semesterThree}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.semesterThree}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.semesterThree)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="semesterFour">Semester 4 Marksheet :</label>
                  {uploadProgress.semesterFour > 0 && (
                    <div>
                      <progress value={uploadProgress.semesterFour} max="100" />
                      <span>{uploadProgress.semesterFour}%</span>
                    </div>
                  )}
                  {!previewCert.semesterFour ? (
                    <input
                      type="file"
                      name="semesterFour"
                      onChange={handleFileChange}
                      disabled={previewCert.semesterFour}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.semesterFour}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.semesterFour)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="semesterFive">Semester 5 Marksheet :</label>
                  {uploadProgress.semesterFive > 0 && (
                    <div>
                      <progress value={uploadProgress.semesterFive} max="100" />
                      <span>{uploadProgress.semesterFive}%</span>
                    </div>
                  )}
                  {!previewCert.semesterFive ? (
                    <input
                      type="file"
                      name="semesterFive"
                      onChange={handleFileChange}
                      disabled={previewCert.semesterFive}
                    />

                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.semesterFive}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.semesterFive)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="semesterSix">Semester 6 Marksheet :</label>
                  {uploadProgress.semesterSix > 0 && (
                    <div>
                      <progress value={uploadProgress.semesterSix} max="100" />
                      <span>{uploadProgress.semesterSix}%</span>
                    </div>
                  )}
                  {!previewCert.semesterSix ? (
                    <input
                      type="file"
                      name="semesterSix"
                      onChange={handleFileChange}
                      disabled={previewCert.semesterSix}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.semesterSix}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.semesterSix)
                          }
                        >
                          Delete
                        </button>
                      </div>

                    </>
                  )}
                </div>
                {(spldata.ctype === '7' ||
                  spldata.ctype === '71' ||
                  spldata.ctype === '72' ||
                  spldata.ctype === '73') && (
                    <div className="form-group">
                      <label htmlFor="semesterSeven">
                        Semester 7 Marksheet :
                      </label>
                      {uploadProgress.semesterSeven > 0 && (
                        <div>
                          <progress value={uploadProgress.semesterSeven} max="100" />
                          <span>{uploadProgress.semesterSeven}%</span>
                        </div>
                      )}
                      {!previewCert.semesterSeven ? (
                        <input
                          type="file"
                          name="semesterSeven"
                          onChange={handleFileChange}
                          disabled={previewCert.semesterSeven}
                        />
                      ) : (
                        <>
                          <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "right",
                              alignItems: "center",
                              width: "100%",
                              margin: "10px 0px",
                            }}
                          >
                            <a
                              className="viewButton"
                              href={`${previewCert.semesterSeven}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View
                            </a>
                            <button
                              className="deleteButton"
                              onClick={() =>
                                handleFileDelete(previewCert.semesterSeven)
                              }
                            >
                              Delete
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                {(spldata.ctype === '71' || spldata.ctype === '73') && (
                  <div className="form-group">
                    <label htmlFor="semesterEight">
                      Semester 8 Marksheet :
                    </label>
                    {uploadProgress.semesterEight > 0 && (
                      <div>
                        <progress value={uploadProgress.semesterEight} max="100" />
                        <span>{uploadProgress.semesterEight}%</span>
                      </div>
                    )}
                    {!previewCert.semesterEight ? (
                      <input
                        type="file"
                        name="semesterEight"
                        onChange={handleFileChange}
                        disabled={previewCert.semesterEight}
                      />
                    ) : (
                      <>
                        <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "right",
                            alignItems: "center",
                            width: "100%",
                            margin: "10px 0px",
                          }}
                        >
                          <a
                            className="viewButton"
                            href={`${previewCert.semesterEight}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View
                          </a>
                          <button
                            className="deleteButton"
                            onClick={() =>
                              handleFileDelete(previewCert.semesterEight)
                            }
                          >
                            Delete
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </>
            )}
          </section>
          <section>


            {showReservation && <h3>Reservation Certificates</h3>}
            {spldata.firstGraduate === "Y" && (
              <>
                <div className="form-group">
                  <label htmlFor="firstGraduate">
                    First Graduate Certificate :
                  </label>
                  {uploadProgress.firstGraduate > 0 && (
                    <div>
                      <progress value={uploadProgress.firstGraduate} max="100" />
                      <span>{uploadProgress.firstGraduate}%</span>
                    </div>
                  )}
                  {!previewCert.firstGraduate ? (
                    <input
                      type="file"
                      name="firstGraduate"
                      onChange={handleFileChange}
                      disabled={previewCert.firstGraduate}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.firstGraduate}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.firstGraduate)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}

            {spldata.disability === "Y" && (
              <>
                <div className="form-group">
                  <label htmlFor="disabilityCertificate">
                    Disability Certificate 1:
                  </label>
                  {uploadProgress.disabilityCertificate1 > 0 && (
                    <div>
                      <progress value={uploadProgress.disabilityCertificate1} max="100" />
                      <span>{uploadProgress.disabilityCertificate1}%</span>
                    </div>
                  )}
                  {!previewCert.disabilityCertificate1 ? (
                    <input
                      type="file"
                      name="disabilityCertificate1"
                      onChange={handleFileChange}
                      disabled={previewCert.disabilityCertificate1}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.disabilityCertificate1}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.disabilityCertificate1)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="disabilityCertificate">
                    Disability Certificate 2:
                  </label>
                  {uploadProgress.disabilityCertificate2 > 0 && (
                    <div>
                      <progress value={uploadProgress.disabilityCertificate2} max="100" />
                      <span>{uploadProgress.disabilityCertificate2}%</span>
                    </div>
                  )}
                  {!previewCert.disabilityCertificate2 ? (
                    <input
                      type="file"
                      name="disabilityCertificate2"
                      onChange={handleFileChange}
                      disabled={previewCert.disabilityCertificate2}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.disabilityCertificate2}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.disabilityCertificate2)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="disabilityCertificate">
                    Disability Certificate 3:
                  </label>
                  {uploadProgress.disabilityCertificate3 > 0 && (
                    <div>
                      <progress value={uploadProgress.disabilityCertificate3} max="100" />
                      <span>{uploadProgress.disabilityCertificate3}%</span>
                    </div>
                  )}
                  {!previewCert.disabilityCertificate3 ? (
                    <input
                      type="file"
                      name="disabilityCertificate3"
                      onChange={handleFileChange}
                      disabled={previewCert.disabilityCertificate3}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.disabilityCertificate3}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.disabilityCertificate3)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}

            {spldata.exService == "Y" && (
              <>
                <div className="form-group">
                  <label htmlFor="exServicemanCertificate">
                    Children of Ex-Serviceman Certificate 1 :
                  </label>
                  {uploadProgress.exServicemanCertificate1 > 0 && (
                    <div>
                      <progress value={uploadProgress.exServicemanCertificate1} max="100" />
                      <span>{uploadProgress.exServicemanCertificate1}%</span>
                    </div>
                  )}
                  {!previewCert.exServicemanCertificate1 ? (
                    <input
                      type="file"
                      name="exServicemanCertificate1"
                      onChange={handleFileChange}
                      disabled={previewCert.exServicemanCertificate1}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.exServicemanCertificate1}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.exServicemanCertificate1)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="exServicemanCertificate">
                    Children of Ex-Serviceman Certificate 2 :
                  </label>
                  {uploadProgress.exServicemanCertificate2 > 0 && (
                    <div>
                      <progress value={uploadProgress.exServicemanCertificate2} max="100" />
                      <span>{uploadProgress.exServicemanCertificate2}%</span>
                    </div>
                  )}
                  {!previewCert.exServicemanCertificate2 ? (
                    <input
                      type="file"
                      name="exServicemanCertificate2"
                      onChange={handleFileChange}
                      disabled={previewCert.exServicemanCertificate2}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.exServicemanCertificate2}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.exServicemanCertificate2)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="exServicemanCertificate">
                    Children of Ex-Serviceman Certificate 3 :
                  </label>
                  {uploadProgress.exServicemanCertificate3 > 0 && (
                    <div>
                      <progress value={uploadProgress.exServicemanCertificate3} max="100" />
                      <span>{uploadProgress.exServicemanCertificate3}%</span>
                    </div>
                  )}
                  {!previewCert.exServicemanCertificate3 ? (
                    <input
                      type="file"
                      name="exServicemanCertificate3"
                      onChange={handleFileChange}
                      disabled={previewCert.exServicemanCertificate3}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.exServicemanCertificate3}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.exServicemanCertificate3)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
            {spldata.sports == "Y" && (
              <>
                <div className="form-group">
                  <label htmlFor="sportsCertificate1">
                    Sports Certificate 1 :
                  </label>
                  {uploadProgress.sportsCertificate1 > 0 && (
                    <div>
                      <progress value={uploadProgress.sportsCertificate1} max="100" />
                      <span>{uploadProgress.sportsCertificate1}%</span>
                    </div>
                  )}
                  {!previewCert.sportsCertificate1 ? (
                    <input
                      type="file"
                      name="sportsCertificate1"
                      onChange={handleFileChange}
                      disabled={previewCert.sportsCertificate1}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.sportsCertificate1}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.sportsCertificate1)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="sportsCertificate2">
                    Sports Certificate 2 :
                  </label>
                  {uploadProgress.sportsCertificate2 > 0 && (
                    <div>
                      <progress value={uploadProgress.sportsCertificate2} max="100" />
                      <span>{uploadProgress.sportsCertificate2}%</span>
                    </div>
                  )}
                  {!previewCert.sportsCertificate2 ? (
                    <input
                      type="file"
                      name="sportsCertificate2"
                      onChange={handleFileChange}
                      disabled={previewCert.sportsCertificate2}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.sportsCertificate2}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.sportsCertificate2)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="sportsCertificate3">
                    Sports Certificate 3 :
                  </label>
                  {uploadProgress.sportsCertificate3 > 0 && (
                    <div>
                      <progress value={uploadProgress.sportsCertificate3} max="100" />
                      <span>{uploadProgress.sportsCertificate3}%</span>
                    </div>
                  )}
                  {!previewCert.sportsCertificate3 ? (
                    <input
                      type="file"
                      name="sportsCertificate3"
                      onChange={handleFileChange}
                      disabled={previewCert.sportsCertificate3}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.sportsCertificate3}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.sportsCertificate3)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="sportsCertificate4">
                    Sports Certificate 4 :
                  </label>
                  {uploadProgress.sportsCertificate4 > 0 && (
                    <div>
                      <progress value={uploadProgress.sportsCertificate4} max="100" />
                      <span>{uploadProgress.sportsCertificate4}%</span>
                    </div>
                  )}
                  {!previewCert.sportsCertificate4 ? (
                    <input
                      type="file"
                      name="sportsCertificate4"
                      onChange={handleFileChange}
                      disabled={previewCert.sportsCertificate4}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.sportsCertificate4}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.sportsCertificate4)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="sportsCertificate5">
                    Sports Certificate 5 :
                  </label>
                  {uploadProgress.sportsCertificate5 > 0 && (
                    <div>
                      <progress value={uploadProgress.sportsCertificate5} max="100" />
                      <span>{uploadProgress.sportsCertificate5}%</span>
                    </div>
                  )}
                  {!previewCert.sportsCertificate5 ? (
                    <input
                      type="file"
                      name="sportsCertificate5"
                      onChange={handleFileChange}
                      disabled={previewCert.sportsCertificate5}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.sportsCertificate5}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.sportsCertificate5)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="sportsCertificate6">
                    Sports Certificate 6 :
                  </label>
                  {uploadProgress.sportsCertificate6 > 0 && (
                    <div>
                      <progress value={uploadProgress.sportsCertificate6} max="100" />
                      <span>{uploadProgress.sportsCertificate6}%</span>
                    </div>
                  )}
                  {!previewCert.sportsCertificate6 ? (
                    <input
                      type="file"
                      name="sportsCertificate6"
                      onChange={handleFileChange}
                      disabled={previewCert.sportsCertificate6}
                    />
                  ) : (
                    <>
                      <input className="fileUpload-inp" type="text" value="Uploaded" disabled />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                          width: "100%",
                          margin: "10px 0px",
                        }}
                      >
                        <a
                          className="viewButton"
                          href={`${previewCert.sportsCertificate6}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                        <button
                          className="deleteButton"
                          onClick={() =>
                            handleFileDelete(previewCert.sportsCertificate6)
                          }
                        >
                          Delete
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}

          </section>
        </div>
        <div className='certificate-upload-bottom'>
          <button onClick={() => navigate('/dashboard')} className="route-home-button">Dashboard</button>
          {downloading ? <button className="cert-list-btn" type="no">Downloading...</button> : <button onClick={handleDownload} className="cert-list-btn">Download Uploaded Certificate List</button>}

        </div>
      </div>
      <PopModal
        isOpen={isModalOpen}
        type={modalType}
        confirmButtonText="OK"
        onConfirm={onConfirm}
        showCancelButton={showCancelButton}
        cancelButtonText="Cancel"
        onCancel={onCancel}
      />
      {message && <p className="message">{message}</p>}
    </div>
  );
}

export default AdminCertUpload;
